import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { DigitStyle } from '@globalx/core'
import type { Language } from '@/i18n'
import { persistStorage } from '@/lib/storage'

export type ThemePref = 'system' | 'dark' | 'light'

interface PreferencesState {
  language: Language
  theme: ThemePref
  digits: DigitStyle
  setLanguage: (language: Language) => void
  setTheme: (theme: ThemePref) => void
  setDigits: (digits: DigitStyle) => void
}

export const PREFS_KEY = 'gx-prefs'

export const usePreferences = create<PreferencesState>()(
  persist(
    (set) => ({
      language: 'ar',
      theme: 'system',
      digits: 'latn',
      setLanguage: (language) => set({ language }),
      setTheme: (theme) => set({ theme }),
      setDigits: (digits) => set({ digits }),
    }),
    { name: PREFS_KEY, storage: persistStorage, version: 1 },
  ),
)
